document.addEventListener('DOMContentLoaded', function() {
  const bottomShopList = document.getElementById('shoplist'); // ボトムのショップリスト取得
  const bottomDeliList = document.getElementById('deli-list'); // ボトムのショップリスト取得

  const takeOut = document.getElementById('take-out');
  const local = document.getElementById('local');
  const ageCheckBox = document.getElementById('age');

  let selectedTakeShop = getCookie("shop"); // 初期クッキー店舗
  let selectedDeliShop = getCookie("deli_shop"); // 初期クッキー店舗
  let appShopList = [];

  selectShoppingMethod();
  let checkMethod = selectShopByMethod()

  if(checkMethod === "local-delivery" ) {
    shopSelect(bottomDeliList,selectedDeliShop);
  } else {
    shopSelect(bottomShopList,selectedTakeShop);
  }

  // 最初のチェックを開始
  checkForButton();

  document.querySelectorAll('[name="method"]').forEach((radio) => {
    radio.addEventListener('click', () => {
        document.querySelectorAll('.method-button').forEach((label) => {
            label.classList.remove('selected');
        });
        const selectedLabel = document.querySelector(`label[for="${radio.id}"]`);
        if (selectedLabel) {
            selectedLabel.classList.add('selected');
        }

        document.cookie = "shoppingMethod=" + radio.value + "; " + "max-age=2592000; " + "path=/";
    });
  });

    // フロートの注文方法を選択

    local.addEventListener('click', function() {
      if (this.checked) {
        recordCookieShop(bottomDeliList,"deli_shop=");
        let selectedDeliShop = getCookie("deli_shop");
        shopSelect(bottomDeliList,selectedDeliShop);
        bottomDeliList.classList.remove('hidden--all');
        bottomShopList.classList.add('hidden--all');
        document.querySelectorAll('button[aria-label="デリバリー"]').forEach(button => {
          button.click();
        });
      }
  });

  takeOut.addEventListener('click', function() {
    let count = 0;
      if (this.checked) {
        recordCookieShop(bottomShopList,"shop=");
        let selectedTakeShop = getCookie("shop");
        shopSelect(bottomShopList,selectedTakeShop);
        bottomDeliList.classList.add('hidden--all');
        bottomShopList.classList.remove('hidden--all');
        document.querySelectorAll('button[aria-label="店舗受け取り"]').forEach(button => {
          button.click();
        });
      }
  });

  // 下のバーでテイクアウトの店舗選択
  bottomShopList.addEventListener('change', function () {
    recordCookieShop(bottomShopList,"shop=");
    const selectedValue = this.value;
    const buttons = document.querySelectorAll('[data-headlessui-state]');

    buttons.forEach(button => {
      const h3 = button.querySelector('h3');
      if (h3) {
        const storeName = button.querySelector('h3').textContent.split(' (')[0];
        if (storeName === selectedValue) {
          button.click();
        }
      }
    });
    deleteLabel();
    notMarketLabel();
    errorItemFinder();
  });

  // 下のバーでデリバリーの店舗選択
  bottomDeliList.addEventListener('change', function () {
    recordCookieShop(bottomDeliList,"deli_shop=");

    deleteLabel();
    notMarketLabel();
    errorItemFinder();
  });

  // 年齢チェックボタン
  ageCheckBox.addEventListener('change', ()=> {
    ageCheck();
    errorItemFinder();
  });

// クッキーの選択店舗書き換え
  function recordCookieShop(list,ck) {
    let selectedShop = list.value;
    document.cookie = ck + selectedShop + "; " + "max-age=2592000; " + "path=/";
  }

  // クッキー保存の店舗チェック
  function getCookie(name) {
    let value = "; " + document.cookie;
    let parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  }



  // 買い物方法選択
  function selectShoppingMethod() {
    const cookie = getCookie('shoppingMethod')
    if (cookie == "take-out" ) {
      takeOut.click();
    } else {
      local.click();
    }
  }

  // 最初のチェック時の実行プログラム
  function checkForButton() {
    let button = document.querySelector('button[data-headlessui-state]');

    if (button) {
      if(checkMethod === "local-delivery" ) {
        console.log('デリバリー側を実行')
        selectShoppingMethod();
        shopSelect(bottomDeliList,selectedDeliShop);


      } else {
        console.log('店頭受け取り側を実行')

        selectCookieShop(); //読み込み時のみ実行できればOK
        selectShopGetter();
        selectShoppingMethod();
        shopSelect(bottomShopList,selectedTakeShop);
      }
        // 各JSはこのタイミングで起動
        takeOutSelectButton();
        deliverySelectButton();
        errorItemFinder();
        floatShowing();
        return;
    }

    setTimeout(checkForButton, 1000);
  }


  // クッキーで取得しているお店をクリック（アプリ）
  function selectCookieShop() {
    let selectedTakeShop = getCookie("shop");
    let appShopList = document.querySelectorAll('[data-headlessui-state]');

    appShopList.forEach(e => {
      let text = "";
      const h3 = e.querySelector('h3');
      if (h3) {
        text = h3.textContent || h3.innerText;
        const span = h3.querySelector('span');

        if (span) {
          text = text.replace(span.textContent || span.innerText, '').trim();
        }
      }

      if (e.nodeName === "BUTTON" && text === selectedTakeShop ) {
        e.click();
      }
    });
  }

  // テワタシの店舗を選択してクッキーに保存（アプリ）
  function selectShopGetter() {
    let shopButtons = document.querySelectorAll('button[data-headlessui-state]');

    shopButtons.forEach(button => {
        button.addEventListener('click', function() {
            const h3 = this.querySelector('h3');
            if (h3) {
                let text = h3.textContent || h3.innerText;
                const span = h3.querySelector('span');

                if (span) {
                    text = text.replace(span.textContent || span.innerText, '').trim();
                }
                let selectedTakeShop = text;
                shopSelect(bottomShopList,selectedTakeShop);
                recordCookieShop(bottomShopList,"shop=");
                deleteLabel();
                notMarketLabel();
                errorItemFinder();
            }
        });
    });

  }


  // デリバリーから店舗受取に戻った時に実行（アプリ）
  function takeOutSelectButton() {
    document.querySelectorAll('button[aria-label="店舗受け取り"]').forEach(button => {
      button.addEventListener('click', function() {
          setTimeout(() => {
            document.querySelectorAll('.method-button').forEach((label) => {
              label.classList.remove('selected');
            });
            takeOut.previousElementSibling.classList.add('selected');
            document.cookie = "shoppingMethod=" + "take-out;" + "max-age=2592000; " + "path=/";

            setTimeout(selectCookieShop, 200);
            setTimeout(selectShopGetter, 300);
            setTimeout(function() {
              let selectedTakeShop = getCookie("shop");
              shopSelect(bottomShopList,selectedTakeShop);
            }, 350);

            setTimeout(deleteLabel, 400);
            setTimeout(notMarketLabel, 500);
            setTimeout(notTakeOut, 500);
            setTimeout(errorItemFinder, 520);

            bottomDeliList.classList.add('hidden--all');
            bottomShopList.classList.remove('hidden--all');
          }, 100)


      });
    });
  }

  // デリバリー押したときに実行（アプリ）
  function deliverySelectButton() {
    document.querySelectorAll('button[aria-label="デリバリー"]').forEach(button => {
      button.addEventListener('click', function() {
        setTimeout(() => {
          document.querySelectorAll('.method-button').forEach((label) => {
            label.classList.remove('selected');
          });
          const localDelivery = document.getElementById('local');
          localDelivery.previousElementSibling.classList.add('selected');
          document.cookie = "shoppingMethod=" + "local-delivery;" + "max-age=2592000; " + "path=/";

          setTimeout(function() {

            let selectedDeliShop = getCookie("deli_shop");
            shopSelect(bottomDeliList,selectedDeliShop);
          }, 350);
          setTimeout(errorItemFinder(), 520);
        }, 100)
        bottomShopList.classList.add('hidden--all');
        bottomDeliList.classList.remove('hidden--all');
      });
    });
  }


  // 取り扱い無しならラベルを付ける
  function notMarketLabel() {
    const addPoints = document.querySelectorAll('.js-not-market');
    let cookieShop = "";
    let checkMethod = selectShopByMethod();
    if(checkMethod === "local-delivery" ) {
      cookieShop = getCookie('deli_shop'); // 店舗を取得
    } else {
      cookieShop = getCookie('shop'); // 店舗を取得
    }


    let notLabel = document.createElement('p');
    notLabel.className = 'item-not-market'
    // notLabel.classList.add('cart-not-market');
    notLabel.innerHTML = "【" + cookieShop + "】取り扱い無し"

    addPoints.forEach(e => {
      let marketList = e.dataset.market;
      let marketListArray;

      if (marketList) {
        marketListArray = marketList.split(',');
      } else {
          // marketListが存在しない場合、空の配列を設定
          marketListArray = [];
      }

      marketListArray.forEach(shop => {
        if (cookieShop == shop) {
          console.log(notLabel);
          let cartItemLabel = e.querySelector('.cart-item-label');
          if (cartItemLabel && cartItemLabel.querySelector('.item-not-market')) {
            console.log('.item-not-marketクラスを持つ子要素が存在します。');
          } else {
            e.querySelector('.cart-item--label').prepend(notLabel);
            console.log('.item-not-marketクラスを持つ子要素は存在しません。');
          }
        }
    })
    }); //addPointsの終了部分
  }


  // 取り扱い無しラベルを全部消す
  function deleteLabel() {
    let labelTags = document.querySelectorAll('.item-not-market');
    labelTags.forEach(element => {
      element.remove();
    });
  }


  // 店舗受取不可商品の処理
  function notTakeOut() {
    let notDeliveryItems = document.querySelectorAll('[data-only-delivery]');
    for(let i = 0; notDeliveryItems.length > i; i++ ) {
      let attributeValue = notDeliveryItems[i].getAttribute('data-only-delivery');
      if (attributeValue === 'true') {
        console.log('トゥルー')
        return true;
      }
    }
    return false;
  }


  // 駄目な物を判定する
  function errorItemFinder() {
    let checkoutButtons = document.querySelectorAll('.js-cart-checkout');
    let notShopList = document.querySelectorAll('.js-not-market');
    let cookieMethod = getCookie('shoppingMethod'); // 買い物方法を取得
    if(cookieMethod === "local-delivery" ) {
      cookieShop = getCookie('deli_shop'); // 店舗を取得
    } else {
      cookieShop = getCookie('shop'); // 店舗を取得
    } // 店舗を取得
    let notShopChecker = false;

    notShopList.forEach(e => {
      let marketList = e.dataset.market;
      let marketListArray;
      if (marketList) {
        marketListArray = marketList.split(',');
      } else {
          // marketListが存在しない場合、空の配列を設定
          marketListArray = [];
      }
      marketListArray.forEach(shop => {
        if (cookieShop == shop) {
          notShopChecker = true;
        }
      });
    });

    const cannotTakeOut = notTakeOut();
    let ageInputChecker = ageCheck();

    if(cookieMethod === "take-out" ) { //店舗受け取りの場合
      if (cannotTakeOut == false && notShopChecker == false && ageInputChecker == true ) {
        checkoutButtons.forEach(e => {
          e.disabled = false;
        });
      } else {
        checkoutButtons.forEach(button => {
          button.disabled = true; // ボタンを無効にする
        });
      }
    } else if (cookieMethod === "local-delivery") { //デリバリーの場合
      if (notShopChecker == false && ageInputChecker == true ) {
        checkoutButtons.forEach(e => {
          e.disabled = false;
        });
      } else {
        checkoutButtons.forEach(button => {
          button.disabled = true; // ボタンを無効にする
        });
      }
    }

  }

  // フロートの店舗選択
  function shopSelect(list,method) {
    console.log(list + 'yes')
    for (let i = 0; i < list.options.length; i++) {
      if (list.options[i].value === method) {
          // 一致するオプションが見つかったら、それを選択状態にする
          list.selectedIndex = i;
          setTimeout(deleteLabel, 400);
          setTimeout(notMarketLabel, 500);
          setTimeout(errorItemFinder, 520);
          break;
      }
    }
  }
    // 買い物方法選択
    function selectShoppingMethod() {
      const cookie = getCookie('shoppingMethod')
      if (cookie == "take-out" ) {
        takeOut.click();
      } else {
        local.click();
      }
    }


  // 選択店名の取得
  function selectShopByMethod() {
    let elements = document.getElementsByName('method');
    let len = elements.length;
    let checkMethod = '';

    for (let i = 0; i < len; i++){
      if (elements.item(i).checked){
          checkMethod = elements.item(i).value;
      }
    }
    return checkMethod;
  }

  // 年齢チェック
  function ageCheck() {
    if (ageCheckBox === null ) {
      return true;
    } else {
      let ageCheckStatus = ageCheckBox.checked;
      const noticeInfo = document.getElementById('notice-age');
      if (ageCheckStatus === true ) {
        noticeInfo.innerText = '';
      } else {
      noticeInfo.innerText = '年齢確認をチェックしてください。';
      }
      return ageCheckStatus;
    }
  }

});

function floatShowing() {
  let bottomBar = document.getElementById('ys-location-bar');
  bottomBar.classList.add('show');
}



// QRコード用の数値生成
const qrNumber = document.getElementById('qrNumber');

function generateNumber() {
  const dayDigit = new Date().getDate() % 10; // 日付の下一桁（0〜9）
  const randomThreeDigits = Math.floor(Math.random() * 1000)
    .toString()
    .padStart(3, '0'); // 000〜999のランダム

  return `${dayDigit}${randomThreeDigits}`; // 合計4桁
}
console.log(generateNumber());
qrNumber.value = generateNumber();